import React, { Component } from 'react';

import PropTypes from 'prop-types';

import AJAX from 'common/AJAX';
import Tooltip from 'common/common/Tooltip';
import { TrackEventContext } from 'common/containers/EventContainer';
import { LoadVideoContext, PlayVideoContext } from 'common/containers/WistiaContainer';
import LandingHelmet from 'common/helmets/LandingHelmet';
import Button from 'common/inputs/Button';
import LandingLogos from 'common/LandingLogos';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import Tappable from 'common/Tappable';
import UppercaseHeader from 'common/UppercaseHeader';
import withContexts from 'common/util/withContexts';
import validateInput from 'common/validateInput';
import LandingNavV2 from 'common/www/LandingNavV2';
import ChelseaImage_1x from 'img/landing/chelsea-small-1x.webp';
import ChelseaImage_2x from 'img/landing/chelsea-small-2x.webp';
import FeatureHighlight1_1x from 'img/landing/feature-highlight-1-1x.webp';
import FeatureHighlight1_2x from 'img/landing/feature-highlight-1-2x.webp';
import FeatureHighlight3_1x from 'img/landing/feature-highlight-3-1x.webp';
import FeatureHighlight3_2x from 'img/landing/feature-highlight-3-2x.webp';
import IdaImage_1x from 'img/landing/ida-small-1x.webp';
import IdaImage_2x from 'img/landing/ida-small-2x.webp';
import FeatureHighlight2_1x from 'img/landing/roadmap-1-1x.webp';
import FeatureHighlight2_2x from 'img/landing/roadmap-1-2x.webp';
import Subdomain1x from 'img/landing/subdomain-1x.webp';
import Subdomain2x from 'img/landing/subdomain-2x.webp';
import UseCases1 from 'img/landing/use-cases-1.webp';
import UseCases2 from 'img/landing/use-cases-4.webp';
import UseCases6 from 'img/landing/use-cases-6.webp';
import VideoCover1x from 'img/landing/video-cover-1x.webp';
import VideoCover2x from 'img/landing/video-cover-2x.webp';

import 'css/components/_LandingV2.scss';
import 'css/components/_LandingHeaderV2.scss';
import 'css/components/_LandingFeatures.scss';
import 'css/components/_LandingIntegrationsV2.scss';
import 'css/components/_LandingTestimonialsV2.scss';

import Megaphone from 'img/icons/megaphone.png';
import LogoAryeo from 'img/landing/aryeo-logo.svg';
import LogoClickUp from 'img/landing/clickup-logo.svg';
import GitHubLogo from 'img/landing/github-logo.svg';
import IntercomLogo from 'img/landing/intercom-logo.svg';
import JiraLogo from 'img/landing/jira-logo.svg';
import LogoMercury from 'img/landing/mercury-logo.svg';
import SalesforceLogo from 'img/landing/salesforce-logo.svg';
import SlackLogo from 'img/landing/slack-logo.svg';
import ZapierLogo from 'img/landing/zapier-logo.svg';
import ZendeskLogo from 'img/landing/zendesk-logo.svg';
import ZebImage from 'img/zeb.jpg';

const VideoID = 'pil7s7hbw3';

class Landing extends Component {
  static propTypes = {
    loadVideo: PropTypes.func,
    playVideo: PropTypes.func,
    router: PropTypes.object,
    trackEvent: PropTypes.func,
  };

  state = {
    blurImg: false,
    email: '',
    error: null,
    showFixedNav: false,
  };

  componentDidMount() {
    document.addEventListener('scroll', this.onScroll, false);

    const { trackEvent } = this.props;
    trackEvent('Viewed Landing Page');
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  }

  onEmailChange = (e) => {
    this.setState({
      email: e.target.value.trim(),
      error: null,
    });
  };

  onLoadVideo = () => {
    const { loadVideo, trackEvent } = this.props;
    loadVideo(VideoID, (video) => {
      if (video.trackingEvents) {
        return;
      }
      video.trackingEvents = true;
      video.bind('play', () => {
        trackEvent('Started Landing Video');
        return video.unbind;
      });
      video.bind('secondchange', (seconds) => {
        if (seconds !== 60) {
          return;
        }
        trackEvent('Finished Landing Video');
        return video.unbind;
      });
    });
  };

  onPlayVideo = () => {
    this.onLoadVideo();

    const { playVideo } = this.props;
    playVideo(VideoID);
  };

  onRegisterClicked = () => {
    const { email } = this.state;
    if (!email || !validateInput.email(email)) {
      this.setState({
        error: true,
      });
      return;
    }

    const { router } = this.props;
    router.push('/register?email=' + encodeURIComponent(email));

    AJAX.post('/api/leads/track', {
      email,
    });
  };

  onScroll = () => {
    const { scrollTop } = document.scrollingElement;

    if (scrollTop > 500) {
      this.setState({
        showFixedNav: true,
      });
    } else {
      this.setState({
        showFixedNav: false,
      });
    }
  };

  renderFixedNav() {
    const { showFixedNav } = this.state;
    var className = 'fixedNavContainer';
    if (showFixedNav) {
      className += ' revealed';
    } else {
      className = 'fixedNavContainer';
    }

    return (
      <div className={className}>
        <LandingNavV2 navStyle="fixedNav" />
      </div>
    );
  }

  renderHeader() {
    return (
      <div className="landingHeader">
        <div className="header">
          <div className="left">
            <h1 className="title">Build better products with customer feedback</h1>
            <span className="subtitle">
              Capture, organize, and analyze product feedback in one place to inform your
              product&nbsp;decisions.
            </span>
            <div className="registerContainer">
              <Link className="cta" to="/register">
                <Button buttonType="greenButton" value="Get Started" />
              </Link>
              <Link
                activeClassName="active"
                className="cta link"
                onTap={this.onMobileLinkClicked}
                to="/request-demo">
                <Button buttonType="ghostButton" value="Request A Demo" />
              </Link>
            </div>
            <p className="trialText">Free sign up · No credit card&nbsp;required</p>
          </div>
          <div className="right">
            <div className="heroContainer">
              <div className="browserContainer" onMouseOver={this.onLoadVideo}>
                {this.renderVideo()}
                <div className="imageContainer">
                  <LazyLoadedImage
                    loading="eager"
                    src={VideoCover1x}
                    srcSet={`${VideoCover1x} 1x, ${VideoCover2x} 2x`}
                    className="videoImage"
                    alt="The admin view of Canny, a customer feedback management tool"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <LandingLogos loading="eager" />
      </div>
    );
  }

  renderVideo() {
    return (
      <Tappable onTap={this.onPlayVideo}>
        <div className="playButtonContainer">
          <div className="playButton" />
          <div className="playButtonLabel">
            <UppercaseHeader>See how it works</UppercaseHeader>
          </div>
        </div>
      </Tappable>
    );
  }

  renderHowItWorks() {
    return (
      <div className="howItWorks">
        <h2 className="header">Your complete customer feedback platform</h2>
        <div className="steps">
          <Link to="/features/collect-feedback" className="step">
            <LazyLoadedImage alt="Collect customer feedback" loading="eager" src={UseCases1} />
            <div className="text">
              <div className="title">Capture product&nbsp;feedback</div>
              <div className="description">
                All in one place so nothing slips through the&nbsp;cracks
              </div>
            </div>
          </Link>
          <div className="icon-chevron-right" />
          <Link to="/features/analyze-feedback" className="step">
            <LazyLoadedImage alt="Analyze customer feedback" loading="eager" src={UseCases2} />
            <div className="text">
              <div className="title">Inform product&nbsp;decisions</div>
              <div className="description">Analyze feedback to see what’s most&nbsp;impactful</div>
            </div>
          </Link>
          <div className="icon-chevron-right" />
          <Link to="/features/product-roadmap" className="step">
            <LazyLoadedImage
              alt="Priorization and product roadmapping"
              loading="eager"
              src={UseCases6}
            />
            <div className="text">
              <div className="title">Prioritize and&nbsp;roadmap</div>
              <div className="description">
                Rank features by priority and build a product&nbsp;roadmap
              </div>
            </div>
          </Link>
          <div className="icon-chevron-right" />
          <Link to="/features/product-changelog" className="step">
            <LazyLoadedImage alt="Product changelog" loading="eager" src={Megaphone} />
            <div className="text">
              <div className="title">Announce product&nbsp;updates</div>
              <div className="description">Engage everyone with your newest&nbsp;features</div>
            </div>
          </Link>
        </div>
      </div>
    );
  }

  renderSubdomainImage() {
    return (
      <div className="subdomainImage">
        <div className="heading">
          <div className="textBlock">
            <h2 className="title">Collect feedback from customers and&nbsp;teammates</h2>
            <div className="subtitle">
              Stop letting ideas slip through the cracks. Collect, analyze, and organize feedback
              and feature requests in a dedicated customer feedback tool. Deliver a better
              customer&nbsp;experience.
            </div>
            <div className="subtitle">
              <Link to="/features">Check out our full list of features &rarr;</Link>
            </div>
          </div>
        </div>
        <div className="heroContainer subdomain">
          <div className="browserContainer">
            <div className="chrome">
              <div className="chromeButtons">
                <div className="chromeButton" />
                <div className="chromeButton" />
                <div className="chromeButton" />
              </div>
            </div>
            <div className="imageContainer">
              <LazyLoadedImage
                alt="Canny's product, where users can post, comment, and vote on feature requests"
                src={Subdomain1x}
                srcSet={`${Subdomain1x} 1x, ${Subdomain2x} 2x`}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFeatures() {
    return (
      <div className="features">
        <div className="featureHighlight">
          <div className="featureImage">
            <LazyLoadedImage
              alt="Customers discussing feature requests in comments"
              src={FeatureHighlight1_1x}
              srcSet={`${FeatureHighlight1_1x} 1x, ${FeatureHighlight1_2x} 2x`}
            />
          </div>
          <div className="featureText">
            <div className="title">Make better product&nbsp;decisions</div>
            <div className="subtitle">
              Uncover valuable customer insights. See which features are most requested. Filter
              feedback by segment and impact. Clarify use cases up front. Don’t waste time building
              the wrong&nbsp;things.
            </div>
          </div>
        </div>
        <div className="featureHighlight">
          <div className="featureImage">
            <LazyLoadedImage
              alt="Prioritization tool with impact/effort scoring"
              src={FeatureHighlight2_1x}
              srcSet={`${FeatureHighlight2_1x} 1x, ${FeatureHighlight2_2x} 2x`}
            />
          </div>
          <div className="featureText">
            <h2 className="title">Prioritize feature requests and build a product&nbsp;roadmap</h2>
            <div className="subtitle">
              Score feedback and feature requests based on priority and add them to your roadmap.
              Integrate with project management tools like Jira, ClickUp, and&nbsp;Asana.
            </div>
          </div>
        </div>
        <div className="featureHighlight">
          <div className="featureImage">
            <LazyLoadedImage
              alt="Email updates sent to users when the feature they requested is built"
              src={FeatureHighlight3_1x}
              srcSet={`${FeatureHighlight3_1x} 1x, ${FeatureHighlight3_2x} 2x`}
            />
          </div>
          <div className="featureText">
            <h2 className="title">Keep everyone engaged with product&nbsp;updates</h2>
            <div className="subtitle">
              Automatically follow up with people when you release a feature. Keep the feedback loop
              going strong. Boost customer engagement and&nbsp;retention.
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderIntegrations() {
    return (
      <div className="landingIntegrationsV2">
        <div className="left">
          <h2 className="title">Works well with your existing&nbsp;workflow</h2>
          <div className="subtitle">
            Canny integrates with tools you already use for customer service, project management,
            and&nbsp;more.
          </div>
          <Link to="/integrations">See all integrations</Link>
        </div>
        <div className="integrationContainer">
          <Link to="/integrations/slack" className="integration slackImage">
            <Tooltip
              className="integrationTooltip"
              position="top"
              value="Slack: Send to any channel for instant&nbsp;notifications">
              <LazyLoadedImage src={SlackLogo} alt="Canny's Slack integration" />
            </Tooltip>
          </Link>
          <Link to="/integrations/intercom" className="integration intercomImage">
            <Tooltip
              className="integrationTooltip"
              position="top"
              value="Intercom: Track feedback from within&nbsp;conversations">
              <LazyLoadedImage src={IntercomLogo} alt="Canny's Intercom integration" />
            </Tooltip>
          </Link>
          <a
            href="https://zapier.com/apps/canny/integrations"
            rel="noopener"
            className="integration zapierImage">
            <Tooltip
              className="integrationTooltip"
              position="top"
              value="Zapier: Unlock and trigger 1,000+&nbsp;apps">
              <LazyLoadedImage src={ZapierLogo} alt="Canny's Zapier integration" />
            </Tooltip>
          </a>
          <Link to="/integrations/jira" className="integration jiraImage">
            <Tooltip
              className="integrationTooltip"
              position="top"
              value="Jira: Keep your product team in&nbsp;sync">
              <LazyLoadedImage src={JiraLogo} alt="Canny's Jira integration" />
            </Tooltip>
          </Link>
          <Link to="/integrations/zendesk" className="integration zendeskImage">
            <Tooltip
              className="integrationTooltip"
              position="top"
              value="Zendesk: Track feedback from support&nbsp;tickets">
              <LazyLoadedImage src={ZendeskLogo} alt="Canny's Zendesk integration" />
            </Tooltip>
          </Link>
          <Link to="/integrations/salesforce" className="integration salesforceImage">
            <Tooltip
              className="integrationTooltip"
              position="top"
              value="Salesforce: Track feedback from prospective&nbsp;customers">
              <LazyLoadedImage src={SalesforceLogo} alt="Canny's Salesforce integration" />
            </Tooltip>
          </Link>
          <Link to="/integrations/github" className="integration githubImage">
            <Tooltip
              className="integrationTooltip"
              position="top"
              value="GitHub: Keep &nbsp;conversations">
              <LazyLoadedImage src={GitHubLogo} alt="Canny's GitHub integration" />
            </Tooltip>
          </Link>
        </div>
      </div>
    );
  }

  renderTestimonials() {
    return (
      <div className="landingTestimonialsV2">
        <div className="testimonials">
          <Link to="/case-studies/clickup" className="testimonial">
            <div className="top">
              <div className="logoContainer">
                <LazyLoadedImage
                  alt="ClickUp case study"
                  className="logo clickup"
                  src={LogoClickUp}
                />
              </div>
              <div className="quote">
                &ldquo;Getting Canny set up couldn’t have been easier. We started with a blank
                canvas and allowed our users to paint the&nbsp;rest.&rdquo;
              </div>
            </div>
            <div className="credit">
              <div className="imgContainer">
                <LazyLoadedImage alt="Zeb Evans" src={ZebImage} />
              </div>
              <div className="text">
                <div className="name">Zeb Evans</div>
                <div className="title">Founder at ClickUp</div>
              </div>
            </div>
          </Link>
          <Link to="/case-studies/aryeo" className="testimonial">
            <div className="top">
              <div className="logoContainer">
                <LazyLoadedImage alt="Aryeo case study" className="logo aryeo" src={LogoAryeo} />
              </div>
              <div className="quote">
                &ldquo;Canny has reduced the number of inbounds in our support inbox by 20%, which
                is a big&nbsp;deal.&rdquo;
              </div>
            </div>
            <div className="credit">
              <div className="imgContainer">
                <LazyLoadedImage
                  alt="Chelsea Darby"
                  src={ChelseaImage_1x}
                  srcSet={`${ChelseaImage_1x} 1x, ${ChelseaImage_2x} 2x`}
                />
              </div>
              <div className="text">
                <div className="name">Chelsea Darby</div>
                <div className="title">Customer Success Lead at Aryeo</div>
              </div>
            </div>
          </Link>
          <Link to="/case-studies/mercury" className="testimonial">
            <div className="top">
              <div className="logoContainer">
                <LazyLoadedImage
                  alt="Mercury case study"
                  className="logo mercury"
                  src={LogoMercury}
                />
              </div>
              <div className="quote">
                &ldquo;We use Canny as a way to distribute product thinking across the team. Now
                that everything is in one place, it’s so much easier and more&nbsp;efficient.&rdquo;
              </div>
            </div>
            <div className="credit">
              <div className="imgContainer ida">
                <LazyLoadedImage
                  alt="Ida Ström"
                  src={IdaImage_1x}
                  srcSet={`${IdaImage_1x} 1x, ${IdaImage_2x} 2x`}
                />
              </div>
              <div className="text">
                <div className="name">Ida Ström</div>
                <div className="title">Product Designer at&nbsp;Mercury</div>
              </div>
            </div>
          </Link>
        </div>
        <div className="seeCaseStudies">
          <Link to="/case-studies">Check out our case&nbsp;studies&nbsp;&rarr;</Link>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="landingV2">
        <LandingHelmet />
        {this.renderFixedNav()}
        {this.renderHeader()}
        {this.renderHowItWorks()}
        {this.renderSubdomainImage()}
        {this.renderFeatures()}
        {this.renderIntegrations()}
        {this.renderTestimonials()}
      </div>
    );
  }
}

export default withContexts({
  loadVideo: LoadVideoContext,
  playVideo: PlayVideoContext,
  trackEvent: TrackEventContext,
})(Landing);
